import React from "react";

import classnames from "classnames";
import sanitize  from "dompurify";
import { Folder, Documents } from "icons";

import { Typography } from "clearsense-ui/components";

const FileName = ({ record, text, handleViewPdf }) =>
  record.highlights ? (
    <div
      onClick={() => handleViewPdf(record.url)}
      className={classnames("flex gap-2", { "hover:underline": record.url })}
    >
      <Typography
        style="large"
        className="text-content-dark dark:text-cs-ui-gray-500"
      >
        {text}
      </Typography>
      <Typography
        style="large"
        className="text-content-dark dark:text-cs-ui-gray-500"
        data-cy="search-results"
      >
        <p
          dangerouslySetInnerHTML={{
            __html: sanitize(record.highlights.document),
          }}
        ></p>
      </Typography>
    </div>
  ) : (
    <Typography
      style="large"
      data-cy="documents-file-name"
      onClick={() => record.url && handleViewPdf(record.url)}
      className={classnames(
        "flex gap-1 text-content-dark dark:text-cs-ui-gray-500",
        {
          "hover:underline": record.url,
        }
      )}
    >
      {record.isDir ? <Folder /> : <Documents />}
      {text}
    </Typography>
  );

export default FileName;
